export default __webpack_public_path__ + "26b6fcaf617b8fdc596fee442fc939c8.png";